// tsParticles v3 option names. v3 silently ignores a particles.js-era name.
export const particlesOptions = {
  fullScreen: { enable: false },
  detectRetina: true,
  particles: {
    number: {
      value: 40,
      density: { enable: true, width: 1750, height: 2000 },
    },
    color: { value: "#1072ba" },
    shape: { type: "circle" },
    opacity: { value: 0.1 },
    size: { value: { min: 1, max: 150 } },
    move: {
      enable: true,
      speed: 1,
      direction: "none",
      random: true,
      straight: false,
      outModes: "out",
    },
  },
  interactivity: {
    detectsOn: "window",
    events: {
      onHover: { enable: true, mode: "repulse" },
      onClick: { enable: true, mode: "repulse" },
      resize: { enable: true },
    },
    modes: {
      repulse: { distance: 150, duration: 4 },
    },
  },
};
